import type { BatMetadataConfigEntry } from './common/types';
import { coreFields, massUnitField } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { wasteFields, wasteQuantityField } from './common/wasteFields';
import { msg } from '@lingui/core/macro';

export const buildingWasteMetadata = {
  displayName: msg({
    message: 'Facilities waste',
    context: 'Activity data schema name for facilities waste',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...buildingCommonFields,
    ...wasteFields,
    ...buildingRevisionFields,
    quantity: wasteQuantityField,
    unit: massUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
